var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "createOidcUserModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("admin.create_oidc_user"),
      },
      on: {
        hide: function ($event) {
          return _vm.resetValues()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createUser()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.create")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("b-input-group-form-input", {
        attrs: {
          id: "username-input",
          "input-group-size": "mb-3",
          type: "text",
          lazy: "true",
          required: "true",
          feedback: "true",
          autofocus: "false",
          label: _vm.$t("message.username"),
          "feedback-text": _vm.$t("admin.required_username"),
        },
        model: {
          value: _vm.username,
          callback: function ($$v) {
            _vm.username = $$v
          },
          expression: "username",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }